module.exports = __webpack_public_path__ + "img/history.d04ab85a.png";